// © Microsoft Corporation. All rights reserved.

import {
    SocialCommentExperienceRenderErrorComment,
    SocialCommentExperienceRenderErrorCommentBox,
    SocialCommentExperienceRenderErrorCommentItem,
    SocialCommentExperienceRenderErrorCommentList,
    SocialCommentExperienceRenderErrorContentPanel,
    SocialCommentExperienceRenderErrorDeleteMenu,
    SocialCommentExperienceRenderErrorDisabledMessage,
    SocialCommentExperienceRenderErrorFollowButton,
    SocialCommentExperienceRenderErrorProfileEducator,
    SocialCommentExperienceRenderErrorReactionMenu,
    SocialCommentExperienceRenderErrorReactionPanel,
    SocialCommentExperienceRenderErrorReplyList,
    SocialCommentExperienceRenderErrorReportMenu,
    SocialCommentExperienceRenderErrorSortBox,
    SocialCommentExperienceRenderErrorTypingUsers,
    SocialCommentExperienceRenderErrorUserCard,
    SocialCommentExperienceRenderErrorUnknownComponent
} from "@msnews/diagnostics";

import { Comment } from "./comment/Comment";
import CommentBox from "./comment/comment-box/CommentBox";
import CommentItem from "./comment/comment-item/CommentItem";
import CommentList from "./comment/comment-list/CommentList";
import ContentPanel from "./comment/content-panel/ContentPanel";
import DisabledMessage from "./comment/disabled-message/DisabledMessage";
import ProfileEducator from "./comment/profile-educator/ProfileEducator";
import ReplyList from "./comment/reply-list/ReplyList";
import TypingUsers from "./comment/typing-users/TypingUsers";
import UserCard from "./comment/user-card/UserCard";

import DeleteMenu from "./common/delete-menu/DeleteMenu";
import ReactionMenu from "./common/reaction-menu/ReactionMenu";
import ReactionPanel from "./common/reaction-panel/ReactionPanel";
import ReportMenu from "./common/report-menu/ReportMenu";
import SortBox from "./common/sort-box/SortBox";

import FollowButton from "./follow-button/FollowButton";

export const RenderErrors = {
    [Comment.name]: SocialCommentExperienceRenderErrorComment,
    [CommentBox.name]: SocialCommentExperienceRenderErrorCommentBox,
    [CommentItem.name]: SocialCommentExperienceRenderErrorCommentItem,
    [CommentList.name]: SocialCommentExperienceRenderErrorCommentList,
    [ContentPanel.name]: SocialCommentExperienceRenderErrorContentPanel,
    [DeleteMenu.name]: SocialCommentExperienceRenderErrorDeleteMenu,
    [DisabledMessage.name]: SocialCommentExperienceRenderErrorDisabledMessage,
    [FollowButton.name]: SocialCommentExperienceRenderErrorFollowButton,
    [ProfileEducator.name]: SocialCommentExperienceRenderErrorProfileEducator,
    [ReactionMenu.name]: SocialCommentExperienceRenderErrorReactionMenu,
    [ReactionPanel.name]: SocialCommentExperienceRenderErrorReactionPanel,
    [ReplyList.name]: SocialCommentExperienceRenderErrorReplyList,
    [ReportMenu.name]: SocialCommentExperienceRenderErrorReportMenu,
    [SortBox.name]: SocialCommentExperienceRenderErrorSortBox,
    [TypingUsers.name]: SocialCommentExperienceRenderErrorTypingUsers,
    [UserCard.name]: SocialCommentExperienceRenderErrorUserCard,
    UnknownComponent: SocialCommentExperienceRenderErrorUnknownComponent
};